import React from "react";
import moment from "moment";
import budgetHomeIcon from "../../../assets/images/savings.png";
import "../BudgetReportDashboard.css";
export const BudgetReportMain = (props) => {
  const calculateFinancials = (categories) => {
    let totalBudget = 0;
    let totalTransactions = 0;

    categories.forEach((category) => {
      totalBudget += category.totalBudget;
      totalTransactions += category.totalTransactions;
    });

    const savingsPotential = totalBudget - totalTransactions;

    return { totalBudget, totalTransactions, savingsPotential };
  };
  const financialData = props && props.data && calculateFinancials(props.data);
  const Incomereport = [
    {
      id: 1,
      name: "Monthly Budget Total",
      passiveIncome:
        financialData &&
        financialData.savingsPotential &&
        financialData.savingsPotential,
      earnedIncome:
        financialData && financialData.totalBudget && financialData.totalBudget,
      total:
        financialData && financialData.totalBudget && financialData.totalBudget, // Adjusted to reflect total budget
    },
    {
      id: 2,
      name: "Savings Potential",
      passiveIncome:
        financialData &&
        financialData.totalTransactions &&
        financialData.totalTransactions, // Adjusted to reflect total transactions (expenses)
      earnedIncome:
        financialData &&
        financialData.savingsPotential &&
        financialData.savingsPotential,
      total:
        financialData &&
        financialData.savingsPotential &&
        financialData.savingsPotential, // Adjusted to reflect savings potential
    },
  ];
  return (
    <React.Fragment>
      <div className="budgetCard1">
        <div className="budget-home-icon-container1">
          <div className="budget-home-icon1">
            <img src={budgetHomeIcon} alt="" />
          </div>
          <h3 className="budgetReportheading">Budget Report</h3>
        </div>
        <div className="budgetRow">
          <div>
            <h3 className="budgetReportheading">Synopsis: </h3>
            <p className="budgetReportPara">All expenses and goal savings</p>
          </div>
          <div>
            <div className="budgetReportrow">
              <div className="budgetReportrowData">
                <span className="budegtReportTitle"> Client Name</span>
                <span className="budgetReportsubTitle">
                  {" "}
                  {localStorage.getItem("User") ? (
                    localStorage.getItem("User")
                  ) : (
                    <React.Fragment></React.Fragment>
                  )}
                </span>
              </div>
              <div className="budgetReportrowData">
                <span className="budegtReportTitle"> Today's Date </span>
                <span className="budgetReportsubTitle"> {moment().format("MM/DD/YYYY")}</span>
              </div>
            </div>
            {/*
            <div className="reportrow2">
              <div className="budgetReportrowData">
                <span className="budegtReportTitle"> Spouse Name</span>
                <span className="budgetReportsubTitle"> Tracy Jones</span>
              </div>
              <div className="budgetReportrowData">
                <span className="budegtReportTitle"> Today's Date </span>
                <span className="budgetReportsubTitle">
                  {" "}
                  {moment().format("MM/DD/YYYY")}
                </span>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {Incomereport &&
        Incomereport.map((item, index) => (
          <div key={index} className="budgetCard2">
            <h3 className="BudgetReportheading">{item.name}</h3>
            <div className="budgetRow">
              <div>
                <div className="budgetReportrow1">
                  <div className="budgetReportrowData">
                    <span className="budgetreportTitle">
                      {" "}
                      {item.name === "Monthly budget total"
                        ? "Expenses/Budget"
                        : " All Income"}{" "}
                    </span>
                    <span className="budgetreportsubTitle2">
                      $
                      {item.passiveIncome
                        ? item.passiveIncome
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : 0}
                    </span>
                  </div>
                  <div className="budgetReportrowData">
                    <span className="budgetreportTitle">
                      {item.name === "Monthly budget total"
                        ? "Assigned to"
                        : " All Budget"}{" "}
                    </span>
                    <span className="budgetreportsubTitle2">
                      {" "}
                      $
                      {item.earnedIncome
                        ? item.earnedIncome
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : 0}
                    </span>
                  </div>
                </div>
                <div className="budgetReportrow2">
                  <div className="budgetReportrowData">
                    <span className="budgetreportTitle">
                      {item.name === "Monthly budget total"
                        ? "2019"
                        : " Savings Potential"}{" "}
                    </span>
                    <span className="budgetreportsubTitle2">
                      {" "}
                      $
                      {item.earnedIncome
                        ? item.earnedIncome
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : 0}
                    </span>
                  </div>
                </div>
                <div className="budgetreportrow2">
                  <div className="budgetreportrowData1">
                    <span className="budgetreportTitle">
                      {item.name === "Monthly budget total"
                        ? "Monthly Budget Total"
                        : " Total Saving"}
                    </span>
                    <span className="budgetreportsubTitle2">
                      {" "}
                      $
                      {item.total
                        ? item.total
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : 0}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
    </React.Fragment>
  );
};
